import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { CustomerService } from 'src/app/shared/services/customer.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'pme-self-attendance',
    templateUrl: './self-attendance.component.html',
    standalone: false
})

export class SelfAttendanceComponent implements OnInit {
  userId: string;
  businessId: string;
  classificationIdentifier: string;

  constructor(    
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService,
    private sessionStorageService: SessionStorageService,
  ) {

    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
  
    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
      }
    });
  }

  ngOnInit() {
    if (this.classificationIdentifier === "consulta-e-recuperacao-de-dividas") {
      this.checkPackageSelfAttendanceAvailability();  
    }
  }

  checkPackageSelfAttendanceAvailability(){
    this.customerService
      .getContractStatusByProvisioningParameters(this.businessId, this.userId, "plano-mensal")
      .subscribe(
        (result) => {
          if (result) {
            if (result.product.classification === "plano-mensal" && result.contractStatus === "ACTIVE"){
              window.location.href = 'https://www.serasaempreendedor.com.br/';
            }
          }
        }
      );
  }
}